export enum ButtonClass {
  'PRIMARY' = 'primary',
  'RAISED' = 'mat-raised-button',
  'ICON' = 'mat-icon-button',
  'FAB' = 'mat-fab',
  'MINI-FAB' = 'mat-mini-fab',
  'STROKED' = 'mat-stroked-button',
  'FLAT' = 'mat-flat-button',
}
